import React, { forwardRef } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import Select from '../../input-fields/select';

// Gets all "Run" events
const eventsQuery = graphql`
  {
    allContentfulDataEvent(
      filter: { eventType: { in: ["Run"] }, hideFromListings: { eq: false } }
    ) {
      nodes {
        eventName
      }
    }
  }
`;

const FundraisingEvents = forwardRef(({ required, options, ...rest }, ref) => {
  // Gets the fundraising events from Contentful
  let fundraisingEvents = useStaticQuery(
    eventsQuery
  ).allContentfulDataEvent.nodes.map((event) => ({
    label: event.eventName,
    value: event.eventName,
  }));

  // Adds any extra fields set in the "Options" field in contentful
  fundraisingEvents = fundraisingEvents.concat(
    options.map((option) => ({
      label: option.label,
      value: option.label,
    }))
  );

  return (
    <Select
      {...rest}
      ref={ref}
      options={fundraisingEvents}
      required={required}
      placeholder={required}
    />
  );
});

FundraisingEvents.displayName = 'FundraisingEvents';

FundraisingEvents.propTypes = {
  required: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
};

export default FundraisingEvents;
